export default "__VITE_PUBLIC_ASSET__09936db6__"